export default "__VITE_ASSET__SBvmHQigMJAF8o1IgK_XnQ__"